import { Image } from '@/atoms/Image'
import { InternalLink } from '@/atoms/InternalLink'
import { HeadingLG } from '@/atoms/Text'
import { paths } from '@/constants/paths'

interface ExhibitorsHeaderProps {
  logo: string
}

export const ExhibitorsHeader: React.FC<ExhibitorsHeaderProps> = ({ logo }) => {
  return (
    <div className="flex h-80 flex-col items-center justify-center bg-black">
      <InternalLink className="cursor-pointer no-underline" href={paths.press.index}>
        <HeadingLG color="white" weight="bold">
          Exhibitor Kit
        </HeadingLG>
      </InternalLink>
      <div className="relative mt-8 h-1/3 w-2/3 max-w-[1000px]">
        <Image alt="angel logo" className="bg-transparent object-contain" fill src={logo} />
      </div>
    </div>
  )
}
